import * as React from 'react';
import PropTypes from 'prop-types';
import ReactVirtualized from './index';

const { SortDirection } = ReactVirtualized;

/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
export default function SortIndicator(props) {
	const { sortDirection, indicatorIcon } = props;

	return (
		<>
			{sortDirection === SortDirection.DESC ? (
				<img
					alt="desc"
					style={{ transform: 'scaleY(-1)', marginLeft: '8px' }}
					src={indicatorIcon}
				/>
			) : (
				<img alt="asc" style={{ marginLeft: '8px' }} src={indicatorIcon} />
			)}
		</>
	);
}

SortIndicator.propTypes = {
	indicatorIcon: PropTypes.string,
	sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),
};
